
/* injects from baggage-loader */

'use strict';

import { Puzzle } from '../../../index.const';

import $ from 'jquery';

export default class PuzzleController {
    constructor($log, $element, $timeout, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$element = $element;
        this.$timeout = $timeout;
        this.Trophies = Trophies;
        this.puzzle = Puzzle;
    }

    $onInit(){
        this.throphies = this.Trophies.getThrophies()
        this.$timeout(this.renderPuzzle.bind(this));
    }

    renderPuzzle(){
        $(this.$element).find('.puzzle .part').each((index, element) => {
            let $ele = angular.element(element);
            
            $ele.hasClass('collected')
                ? $ele.css('background-image', `url(${$ele.attr('data-background')})`)
                : this.$log.log(index, element)
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/puzzle/puzzle.controller.js